<template>
    <div>
        <Header></Header>
    </div>
</template>

<script>
import Header from './header.vue';

export default {
    components: {
        Header,
    },
    data () {
        return {

        };
    },
    methods: {},
    mounted () {

    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/hzyc.scss';

::v-deep .header {
    .content {
        .right {
            .nav {
                .nav-item {
                    &.active,
                    &:hover {
                        color: $primaryColor !important;

                        &:after {
                            background: $primaryColor !important;
                        }
                    }
                }
            }

            .info {
                .phone {
                    .iconfont {
                        color: $primaryColor !important;
                    }
                }

                .btn {
                    .el-button {
                        border: 1px solid $primaryColor !important;
                    }
                    .primary-a {
                        color: $primaryColor !important;
                        &:hover {
                            color: $primaryColor9 !important;
                        }
                    }
                }
            }
        }
    }
}

::v-deep .content {
    .right {
        .nav {
            .nav-item {
                &.active,
                &:hover {
                    color: $primaryColor !important;

                    &:after {
                        background: $primaryColor !important;
                    }
                }
            }
        }

        .info {
            .phone {
                .iconfont {
                    color: $primaryColor !important;
                }
            }

            .btn {
                .el-button {
                    border: 1px solid $primaryColor !important;
                }
                .primary-a {
                    color: $primaryColor !important;
                    &:hover {
                        color: $primaryColor9 !important;
                    }
                }
            }
        }
    }
}
</style>